// const MAIN_URL = 'https://www.azimirang.com/';
const MAIN_URL = 'https://azimirang.com/';

export const GET_HOME_PAGE = `${MAIN_URL}api/content/homepage/`;
export const GET_ALL_FILTERS = `${MAIN_URL}api/content/all-filters/`;
export const GET_BRANDS = `${MAIN_URL}api/product/brand/list/`;
export const ORDER_SUBMIT = `${MAIN_URL}api/product/order/submit/`;
export const DISCOUNT_INQUERY = `${MAIN_URL}api/discount/inquery/`;
export const GET_PRODUCT_CATEGORIES_LIST = `${MAIN_URL}api/product/category/list/`
export const GET_PRODUCT_DETAIL = `${MAIN_URL}api/product/detail/`;
export const GET_TAGS = `${MAIN_URL}api/tags.json`;
export const GET_ORDERS = `${MAIN_URL}api/product/order/list/`;
export const GET_REVIEWS = `${MAIN_URL}api/reviews.json`;
export const GET_BANNERS = `${MAIN_URL}api/banners.json`;
export const GET_CAROUSEL = `${MAIN_URL}api/carousel.json`;
export const GET_PRODUCTS = `${MAIN_URL}api/product/list/`;
export const GET_AUDIENCES = `${MAIN_URL}api/audiences.json`;
export const GET_PROMOCODES = `${MAIN_URL}api/discount/discounts/`;
export const GET_CATEGORIES = `${MAIN_URL}api/categories.json`;
export const LOGIN = `${MAIN_URL}api/auth/login/`;
export const REGISTER = `${MAIN_URL}api/auth/register/`;
export const GET_PROFILE = `${MAIN_URL}api/auth/profile/`;

export const URLS = {
  LOGIN,
  REGISTER,
  GET_HOME_PAGE,
  GET_ALL_FILTERS,
  GET_PROFILE,
  GET_BRANDS,
  GET_PRODUCT_CATEGORIES_LIST,
  GET_TAGS,
  GET_ORDERS,
  GET_BANNERS,
  GET_REVIEWS,
  GET_CAROUSEL,
  GET_PRODUCTS,
  GET_PRODUCT_DETAIL,
  GET_AUDIENCES,
  GET_PROMOCODES,
  GET_CATEGORIES,
  ORDER_SUBMIT,
  DISCOUNT_INQUERY,
};
